import './ProductReviewCreateComment.css'
import React, { useState } from 'react'
import { langMessages } from './lang'
import { lang, axiosConfig } from '../../../../../common/baseData';

/**
 *
 * AUTHOR - фамилия имя автора
 * DATE_TIME - форматированная дата отзыва
 * RATING - рейтинг
 * POST_TEXT - текст отзыва
 * ID - идентификатор отзыва
 * POST_ID - идентификатор блога для твоара
 * BLOG_ID - идентификатор блога
 * PARENT_ID - false, т.к корневой отзыв
 * COMMENTS - список комментариев
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function ProductReviewCreateComment (props) {
  const createUrl = '/local/templates/tehnoezh-modern/components/bitrix/blog.post.comment/json/ajax.php'
  const [created, setCreated] = useState(false)
  const [fields, setFields] = useState({
    name: {
      valid: true,
      value: ''
    },
    email: {
      valid: true,
      value: ''
    },
    message: {
      valid: true,
      value: ''
    }
  })

  function getMessage (code) {
    return langMessages.hasOwnProperty(lang) && langMessages[lang].hasOwnProperty(code) ?
      langMessages[lang][code] : `lang message: ${code} not defined`
  }

  /**
   * Изменение значения поля
   * @param e
   */
  function onChange (e) {
    switch (e.target.getAttribute('name')) {
      case 'name':
        setFields({ ...fields, name: { value: e.target.value, valid: nameValidator(e.target) } })
        break
      case 'email':
        setFields({ ...fields, email: { value: e.target.value, valid: emailValidator(e.target) } })
        break
      case 'message':
        setFields({ ...fields, message: { value: e.target.value, valid: textValidator(e.target) } })
        break
      default:
        break
    }
  }

  /**
   * Сохранение комментария
   * @param e
   */
  function obSubmit (e) {
    e.preventDefault()
    let formData = new FormData()
    formData.append('action', 'createReview')
    formData.append('sessid', sessid)
    formData.append('parentId', props.ID)
    formData.append('postId', props.POST_ID)
    formData.append('blogId', props.BLOG_ID)
    formData.append('productId', props.productId)

    // Добавляем данные из формы
    for (let fieldName in fields) {
      if (fields.hasOwnProperty(fieldName) && fields[fieldName].value.length) {
        formData.append(fieldName, fields[fieldName].value)
      }
    }

    fetch(createUrl, { body: formData, method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => response.json())
      .then(response => {
        if (response.success && response.reviewId > 0)
          setCreated(true)
      })
  }

  function nameValidator (input) {
    return /^[a-zA-ZА-Яа-яЁёЇїІіЄєҐґ]+([ʼ'-][a-zA-ZА-Яа-яЁёЇїІіЄєҐґ]+)?(\s[a-zA-ZА-Яа-яЁёЇїІіЄєҐґ']+)?$/g.test(input.value)
  }

  function emailValidator (input) {
    return /^([a-zA-Z0-9_.+-])+(\@([a-zA-Z0-9-])+\.)+.+([a-zA-Z0-9])+$/.test(input.value)
  }

  function textValidator (input) {
    return (!(input.value.length <= 0 || input.value.length > 1000))
  }

  return (
    <div className="dropdown-holder">
      <div className="dropdown-conteiner">
        <span className="close" onClick={props.showHide}/>
        {
          !created ?
            <div className="dropdown-content-te">
              <div className="form-box">
                <form name="comment" className="form_validate review_form">
                  <div className="review-form-content">
                    {
                      props.hasOwnProperty('currentUser') && props.currentUser.hasOwnProperty('ID') && parseInt(props.currentUser.ID) > 0 ?
                        <></> :
                        <>
                          <div className="row row-items">
                            <div className="input-holder field">
                              <input name="name" type="text"
                                     value={fields.name.value}
                                     onChange={onChange}
                                     className={`input form-control${fields.name.value.length ? ' has-value' : ''}${!fields.name.valid ? ' error' : ''}`}/>
                              <span className="label-input">{getMessage('COMMENT_NAME')}</span>
                            </div>
                            <div className="input-holder field">
                              <input name="email" type="text"
                                     value={fields.email.value}
                                     onChange={onChange}
                                     className={`input form-control${fields.email.value.length ? ' has-value' : ''}${!fields.email.valid ? ' error' : ''}`}/>
                              <span className="label-input">{getMessage('COMMENT_EMAIL')}</span>
                            </div>
                          </div>
                          <div className="row">
                        <span className="modal-subtitle">{getMessage('COMMENT_OR')}&nbsp;
                          <span className="link-name" data-container="user" data-use="auth">
                            {getMessage('COMMENT_AUTHORIZE')}
                          </span>
                        </span>
                          </div>
                        </>
                    }
                    <div className="row">
                      <div className="input-holder field">
                    <textarea name="message"
                              className={`textarea input form-control${fields.message.value.length ? ' has-value' : ''}${!fields.message.valid ? ' error' : ''}`}
                              onChange={onChange}
                              value={fields.message.value}/>
                        <span className="label-input">{getMessage('COMMENT_TEXT')}</span>
                      </div>
                    </div>
                    <div className="row submit-holder">
                      <input type="submit"
                             className="btn btn-submit"
                             value={getMessage('COMMENT_PUBLISH')}
                             onClick={obSubmit}/>
                    </div>
                  </div>
                </form>
              </div>
            </div> :
            <div className="thx-box" style={{display: "block"}}>
              <div className="thx-tomorrow">
                <span>{getMessage('COMMENT_PUBLISH_AFTER_MODERATE')}</span>
              </div>
            </div>
        }
      </div>
    </div>
  )
}

export default ProductReviewCreateComment